import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-dropdown-custom',
  templateUrl: './dropdown-custom.component.html',
  styleUrls: ['./dropdown-custom.component.less']
})
export class DropdownCustomComponent implements OnInit, OnDestroy {
  dropdownLabel: string;
  sourceListValue: any[];
  @Input() selectedIds: number[] = [];
  @Input() disabled = false;
  @Output() userChoice: EventEmitter<number[]> = new EventEmitter<number[]>();
  dropdown: boolean;
  @Input() displayExpr: Function;
  @Input() bgWhite = false;

  @Input()
  set sourceList(val) {
    this.sourceListValue = val;
    this.ngOnInit();
  }

  get sourceList() {
    return this.sourceListValue;
  }

  constructor() {
  }

  ngOnInit() {
    this.sourceList.forEach(s => {
      s.isChecked = this.selectedIds.includes(s.id);
    });
    this.showDropdownLabel();
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
      this.userChoice.emit(this.sourceList.filter(s => s.isChecked).map(s => s.id));
    }
  }

  toggleDropdown() {
    if (!this.disabled) {
      this.dropdown = !this.dropdown;
    }
  }

  showDropdownLabel() {
    const listSelectedItem = this.sourceList.filter(s => s.isChecked);
    const length = listSelectedItem.length;
    if (length) {
      if (length === 1) {
        const selectedUser = listSelectedItem[0];
        this.dropdownLabel = this.displayExpr(selectedUser);
      } else {
        this.dropdownLabel = '(' + length + ' selected)';
      }
    } else {
      this.dropdownLabel = '';
    }
  }

  onSelectedUser(isChecked: boolean, user: any) {
    if (!this.disabled) {
      user.isChecked = isChecked;
      this.showDropdownLabel();
      this.userChoice.emit(this.sourceList.filter(s => s.isChecked).map(s => s.id));
    }
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown-custom/dropdown-custom.component.ts